import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="products"
export default class extends Controller {

  static targets = ["input", "type", "form", "output"]
  
  getTotal() {
    this.showLoading()
    const checkedBoxes = Array.from(this.element.querySelectorAll("input[type='checkbox']:checked"))
    if (!checkedBoxes.length) return this.setEmpty()
    const ids = checkedBoxes.map(checkbox => Number(checkbox.value))
    this.inputTarget.value = JSON.stringify(ids)
    this.formTarget.requestSubmit()
  }

  togglePrice(event) {
    this.showLoading()
    if (this.typeTarget.value === "gross") {
      this.typeTarget.value = "net"
    } else {
      this.typeTarget.value = "gross"
    }
    this.getTotal()
  }

  showLoading() {
    this.outputTarget.innerText = "..."
  }

  setEmpty() {
    this.outputTarget.innerText = ""
  }

}
